import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import CheckinFormBuilder from "@/modules/performance/admin/components/checkin-form/CheckinFormBuilder";
import { fetchCheckinFormQueryOptions } from "@/modules/performance/admin/services";

const searchSchema = z.object({
  step: z.number().optional(),
});

export const Route = createFileRoute(
  "/admin/_panel/_performance/performance/checkins-meetings/forms/$id",
)({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "performance.performance-checkin-form.update",
    );

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Edit Question", {
            ns: "performance.admin",
          }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchCheckinFormQueryOptions(opts.params.id),
    ),
});

function Component() {
  const { id } = Route.useParams();

  return <CheckinFormBuilder id={id} />;
}
